import styled from "styled-components";
import theme from "@src/Tools/MuiTheme";
import { Grid } from "@material-ui/core";

export const STGrid = styled(Grid)`
  && {
    margin-top: 12px;
    margin-bottom: 30px;
    ${theme.breakpoints.only("xs")} {
      justify-content: center;
    }
  }
`;

export const STHomeWrapper = styled.div`
  && {
    max-width: 800px;

    ${theme.breakpoints.down("xs")} {
      min-width: 280px;
    }

    ${theme.breakpoints.up("sm")} {
      min-width: 360px;
    }
  }
`;

export const STPageHeader = styled.h1`
  font-size: 18px;
  margin: 0;
  width: fit-content;
`;
